import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/ommax-textimage.jpg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "row align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-sm-6 order-sm-2" }, [
  /*#__PURE__*/_createElementVNode("figure", null, [
    /*#__PURE__*/_createElementVNode("img", {
      src: _imports_0,
      alt: "Alt Text",
      title: "Title Text",
      class: "img-fluid"
    })
  ])
], -1 /* HOISTED */)
const _hoisted_4 = { class: "col-sm-6 order-sm-1" }
const _hoisted_5 = { class: "text pe-sm-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h4", null, "Leasing-Rechner für Arbeitgeber", -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.", -1 /* HOISTED */)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Donec quam felis, ultricies nec, pellentesque eu, pretium quis, sem. Nulla consequat massa quis enim. Donec pede justo, fringilla vel, aliquet nec, vulputate eget, arcu.", -1 /* HOISTED */)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "In enim justo, rhoncus ut, imperdiet a, venenatis vitae, justo. Nullam dictum felis eu pede mollis pretium. Integer tincidunt. Cras dapibus. Vivamus elementum semper nisi. Aenean vulputate eleifend tellus. Aenean leo ligula, porttitor eu, consequat vitae, eleifend ac, enim. Aliquam lorem ante, dapibus in, viverra quis, feugiat a,", -1 /* HOISTED */)
const _hoisted_10 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            _createElementVNode("p", _hoisted_10, [
              _createVNode(_component_router_link, {
                to: "/calculator",
                class: "btn btn-primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Jetzt berechnen ")
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}